import { ActionTree } from "vuex";
import { RootState } from "../types";
import { GuardChatStore } from "./types";
import * as api from "@/services/api.guardChat.service";

export const actions: ActionTree<GuardChatStore, RootState> = {
	async loadMessages({ commit, state, getters }, eventId: number) {
		const afterId = getters.getLastMessageId(eventId);
		const messages = await api.loadMessages(eventId, afterId);
		if (messages && messages.length > 0) {
			commit("addMessages", { eventId, messages });
			const numberOfUnread = state.guardChatList[eventId]?.numberOfUnread + messages.length;
			commit("setNumberOfUnread", { eventId, numberOfUnread })
		}
	}
};
